<ng-template #template>
  <tr class="event-management-event-row">
    <td>
      <div class="event-management-event-row__event-name">
        {{ event.event_name }}
      </div>
    </td>
    <td>
      <div class="event-management-event-row__categories" *ngIf="event.categories.length > 0">
        <app-badge color="secondary">
          {{ event.categories[0].category_title }}
        </app-badge>

        <app-badge color="light"
                   *ngIf="event.categories.length > 1">

          {{ eventHiddenCategoryCount }}
        </app-badge>
      </div>
    </td>
    <td>
      {{ eventLocation }}
    </td>
    <td>
      {{ eventDate }}
    </td>
    <td>
      <!-- TODO: create custom color mapping based on status -->
      <app-badge color="light">
        {{ 'status_' + event.event_status.id | t }}
      </app-badge>
    </td>
    <td>
      <div class="event-management-event-row__actions">
        <app-button buttonStyle="unstyled"
                    class="event-management-event-row__action-btn">

          <app-icon [name]="ICONS.TRASH" (click)="deleteEvent()"></app-icon>
        </app-button>
        <app-button buttonStyle="unstyled"
                    class="event-management-event-row__action-btn">

          <app-icon [name]="ICONS.EDIT" (click)="editEvent()"></app-icon>
        </app-button>
      </div>
    </td>
  </tr>
</ng-template>
